import type { GetInvoicesStatisticsResponse } from '@vy/api-definition';
import { GetInvoicesStatisticsResponseSchema } from '@vy/api-definition';
import type { UseQueryOptions } from 'react-query';
import { useQuery } from 'react-query';
import { getPrivateApi } from '../../services/api';
import { USE_CACHE_HEADER } from '../../services/api/cache-headers';
import { queryKeys } from '../../services/query-key/query-keys';

export function useInvoiceStatistics(
  customerId?: string,
  options?: UseQueryOptions<GetInvoicesStatisticsResponse>,
) {
  return useQuery({
    queryKey: queryKeys.invoiceStatistics(customerId),
    queryFn: async () => {
      const api = getPrivateApi();
      const getInvoicesStatisticsResponse = await api.getInvoicesStatistics(
        {
          customerId,
        },
        USE_CACHE_HEADER,
      );

      return GetInvoicesStatisticsResponseSchema.parse(getInvoicesStatisticsResponse);
    },
    ...options,
  });
}
